import * as React from "react"
import {AntSwitchSeeker} from "@ui-seeker/core";


const labelActiveStyles = {
    fontWeight: 'bold'
}

export default function AppAntSwitch({ ...props }) {
    return <AntSwitchSeeker
        //color="disabled"
        {...props}
        falseProps={{
            ...props?.falseProps,
            sx: {
                ...!props?.checked && labelActiveStyles,
                ...props?.falseProps?.sx,
            }
        }}
        trueProps={{
            ...props?.trueProps,
            sx: {
                ...props?.checked && labelActiveStyles,
                ...props?.trueProps?.sx,
            }
        }}
    />
}